import styled from "styled-components";

export const Heading = styled.h2`
  font-variation-settings: "wght" 700;
  font-size: 24px;
  line-height: 32px;
  margin: 0;
`;

export const Header = styled.div`
  margin-bottom: 32px;
  padding: 0 32px;
  display: grid;
  gap: 16px;
`;

export const Description = styled.p`
  line-height: 24px;
  color: var(--text-secondary);
`;

export const Wrapper = styled.div`
  background-color: var(--fill-secondary);
  padding: 24px 0 32px 0;
  border-radius: 32px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const ChartWrapper = styled.div`
  padding: 0 8px;
`;
